module.exports = __webpack_public_path__ + "static/media/next.bbedf56e.svg";